import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ErrorBoundary } from '@beef/react';
import { sendCallBackPhoneFillAnalytics, sendCallBackPhoneSubmitAnalytics } from "../../../../../store/selectors/analytics";
import { currentStateList } from "../../../../../constants/state";
import { CaptchaPopup } from "../../../BackCallPopup/components/NewDesignComponents/components/CaptchaPopup";
import { CAPTCHA_STATUS, CaptchaWithCallbackPopupHOC } from "../../../hoc/CaptchaWithCallbackPopupHOC";
// eslint-disable-next-line import/namespace
import { RenderRequestForm } from "../../../BackCallPopup/components/NewDesignComponents/components/RenderRequestForm";
import { RenderRequestStatus } from "../../../BackCallPopup/components/NewDesignComponents/components";
import { store, submitCallbackRequest } from "../../../../../store";
var BackCallBlock = function BackCallBlock(_ref) {
  var data = _ref.data,
    phoneInputValue = _ref.phoneInputValue,
    isPersonalVerificationCheckboxEnable = _ref.isPersonalVerificationCheckboxEnable,
    changeCheckbox = _ref.changeCheckbox,
    isCheckboxChecked = _ref.isCheckboxChecked,
    changePhone = _ref.changePhone,
    showCaptcha = _ref.showCaptcha,
    captchaToken = _ref.captchaToken,
    changeCaptchaToken = _ref.changeCaptchaToken,
    changeCaptchaState = _ref.changeCaptchaState,
    reCaptchaModel = _ref.reCaptchaModel,
    captchaStatus = _ref.captchaStatus,
    changeCaptchaStatus = _ref.changeCaptchaStatus,
    captchaMsg = _ref.captchaMsg,
    changeCaptchaMsg = _ref.changeCaptchaMsg,
    _ref$pageType = _ref.pageType,
    pageType = _ref$pageType === void 0 ? 'fttb_page_ev_' : _ref$pageType,
    _ref$isConvergent = _ref.isConvergent,
    isConvergent = _ref$isConvergent === void 0 ? false : _ref$isConvergent,
    captchaKey = _ref.captchaKey;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    phoneInputStatus = _useState2[0],
    setPhoneInputStatus = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isCaptcha = _useState6[0],
    setIsCaptcha = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    applicationStatus = _useState8[0],
    setApplicationStatus = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    resultApplicationTexts = _useState10[0],
    setResultApplicationTexts = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isCheckboxError = _useState12[0],
    setCheckboxError = _useState12[1];
  var onPhoneFocus = useCallback(function () {
    return function () {
      setPhoneInputStatus(null);
    };
  }, [phoneInputValue]);
  var onBackCallBtnClick = function onBackCallBtnClick() {
    sessionStorage.setItem('backCallPopupIsShown', '1');
    if (phoneInputValue.length !== 10) {
      setPhoneInputStatus('fail');
      return;
    }
    if (!isCheckboxChecked && isPersonalVerificationCheckboxEnable) {
      return;
    }
    setLoading(true);
    setPhoneInputStatus(null);
    setCheckboxError(false);
    var captchaData = {
      captchaToken: captchaToken,
      key: captchaKey
    };
    submitCallbackRequest({
      phoneNumber: "+7".concat(phoneInputValue),
      captchaData: captchaData,
      caseTitle: 'sale'
    }).then(function (response) {
      var shouldShowCaptcha = response.shouldShowCaptcha,
        isCaptchaError = response.isCaptchaError,
        isSucceeded = response.isSucceeded;
      setLoading(false);
      changeCaptchaState(shouldShowCaptcha);
      if (isSucceeded) {
        var _data$texts;
        sendCallBackPhoneSubmitAnalytics(pageType, isConvergent);
        setResultApplicationTexts((_data$texts = data.texts) === null || _data$texts === void 0 || (_data$texts = _data$texts.redesignPopupTexts) === null || _data$texts === void 0 ? void 0 : _data$texts.successPopup);
        setApplicationStatus(currentStateList.success);
      } else if (isCaptchaError) {
        changeCaptchaStatus(shouldShowCaptcha ? CAPTCHA_STATUS.fail : CAPTCHA_STATUS.success);
        changeCaptchaState(shouldShowCaptcha);
        setIsCaptcha(true);
      } else {
        var _data$texts2;
        setResultApplicationTexts((_data$texts2 = data.texts) === null || _data$texts2 === void 0 || (_data$texts2 = _data$texts2.redesignPopupTexts) === null || _data$texts2 === void 0 ? void 0 : _data$texts2.errorPopup);
        setApplicationStatus(currentStateList.fail);
      }
    }).catch(function (err) {
      var _data$texts3;
      console.error(err);
      setResultApplicationTexts((_data$texts3 = data.texts) === null || _data$texts3 === void 0 || (_data$texts3 = _data$texts3.redesignPopupTexts) === null || _data$texts3 === void 0 ? void 0 : _data$texts3.errorPopup);
      setLoading(false);
      setApplicationStatus(currentStateList.fail);
    });
  };
  var onChangePhoneHandler = function onChangePhoneHandler(value) {
    if (value === phoneInputValue) return;
    if (value.length === 10) {
      sendCallBackPhoneFillAnalytics(pageType);
    }
    changePhone(value);
  };
  var onChangeCheckboxHandler = function onChangeCheckboxHandler(value) {
    changeCheckbox(value);
  };
  var closePopup = useCallback(function () {
    setApplicationStatus('');
    setIsCaptcha(false);
  }, [applicationStatus]);
  var callbackData = useMemo(function () {
    return {
      texts: data.texts,
      phoneInputValue: phoneInputValue,
      isCheckboxChecked: isCheckboxChecked,
      changePhone: onChangePhoneHandler,
      changeCheckbox: onChangeCheckboxHandler,
      showCaptcha: showCaptcha,
      captchaToken: captchaToken,
      changeCaptchaToken: changeCaptchaToken,
      reCaptchaModel: reCaptchaModel,
      captchaStatus: captchaStatus,
      changeCaptchaStatus: changeCaptchaStatus,
      phoneInputStatus: phoneInputStatus,
      onPhoneFocus: onPhoneFocus,
      onBackCallBtnClick: onBackCallBtnClick,
      captchaMsg: captchaMsg,
      changeCaptchaMsg: changeCaptchaMsg,
      isCheckboxError: isCheckboxError,
      isPersonalVerificationCheckboxEnable: isPersonalVerificationCheckboxEnable
    };
  }, [phoneInputValue, isCheckboxChecked, onChangePhoneHandler, showCaptcha, captchaToken, changeCaptchaState, captchaMsg, isPersonalVerificationCheckboxEnable]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    "data-t-id": "components-BackCallBlock"
  }, /*#__PURE__*/React.createElement(RenderRequestForm, {
    data: callbackData,
    isLoading: isLoading,
    withActionButton: true,
    "data-t-id": "components-BackCallBlock"
  }), applicationStatus && /*#__PURE__*/React.createElement(RenderRequestStatus, {
    onClose: closePopup,
    texts: resultApplicationTexts
  }), isCaptcha && /*#__PURE__*/React.createElement(CaptchaPopup, {
    data: callbackData,
    isLoading: isLoading,
    onClose: closePopup
  }));
};
var BackCallBlockWithCaptchaHOC = function BackCallBlockWithCaptchaHOC(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(CaptchaWithCallbackPopupHOC, _extends({}, props, {
    "data-t-id": "components-BackCallBlock"
  }), /*#__PURE__*/React.createElement(BackCallBlock, {
    "data-t-id": "components-BackCallBlock"
  })));
};
export { BackCallBlockWithCaptchaHOC as BackCallBlock };
BackCallBlock.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.shape({
    texts: PropTypes.shape({})
  }),
  pageType: PropTypes.string,
  isConvergent: PropTypes.bool,
  phoneInputValue: PropTypes.string,
  changePhone: PropTypes.func,
  showCaptcha: PropTypes.bool,
  captchaToken: PropTypes.string,
  changeCaptchaToken: PropTypes.func,
  changeCaptchaState: PropTypes.func,
  reCaptchaModel: PropTypes.shape({
    refreshCaptcha: PropTypes.number,
    setCaptchaKey: PropTypes.func,
    onChange: PropTypes.func
  }),
  captchaStatus: PropTypes.string,
  changeCaptchaStatus: PropTypes.func,
  captchaMsg: PropTypes.string,
  changeCaptchaMsg: PropTypes.func,
  captchaKey: PropTypes.string,
  isPersonalVerificationCheckboxEnable: PropTypes.bool,
  changeCheckbox: PropTypes.func,
  isCheckboxChecked: PropTypes.bool
} : {};